import { render, staticRenderFns } from "./TreeClassTeam.vue?vue&type=template&id=748730ac&scoped=true"
import script from "./TreeClassTeam.vue?vue&type=script&lang=js"
export * from "./TreeClassTeam.vue?vue&type=script&lang=js"
import style0 from "./TreeClassTeam.vue?vue&type=style&index=0&id=748730ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748730ac",
  null
  
)

export default component.exports